export default "__VITE_ASSET__CvFkDbC7__"